import { CardHeader, Icon } from '@ps/isp-web-component-library';
import { Clock } from '@ps/isp-web-component-library/icons/Clock';
import type { EventId } from '@ps/isp-web-services-types';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import React from 'react';

import { SportsLink } from '@swf/sports/components';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import { useNormalisedEventBasedData } from '@swf/sports/hooks/useNormalisedEventBasedData';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import bgImage from '../../../../header-bg.png';
import PopularBetBuilderCount from '../PopularBetBuilderCount/PopularBetBuilderCount';

import styles from './EventDetailsHeader.scss';

interface Props {
  eventId: EventId;
  popularBetBuilderCount: number;
}

const EventDetailsHeader: React.FC<Props> = ({ eventId, popularBetBuilderCount }) => {
  const isFlameVariantEnabled = useFeature(FeatureFlag.ISPExperimentPopularBetBuilderCount);
  const { event, competition, eventType } = useNormalisedEventBasedData({
    eventId
  });

  const { eventSlug, eventStartTime, enrichedParticipants } = event;
  const [teamAName, teamBName] = enrichedParticipants?.map(({ participant }) => participant) ?? [];

  const { competitionId, competitionSlug } = competition;

  const { eventTypeId, eventTypeSlug } = eventType;

  const sportsLinkValues = {
    eventTypeId,
    eventTypeSlug,
    competitionId,
    competitionSlug,
    eventId,
    eventSlug
  };

  return (
    <CardHeader inline className={styles.cardHeader} style={{ backgroundImage: `url(${bgImage})` }}>
      <div className={styles.eventDetails}>
        <SportsLink alias="sportsEvent" values={sportsLinkValues} className={styles.participants}>
          <span>{teamAName}</span>
          <span>{teamBName}</span>
        </SportsLink>
        <span className={styles.dateTimeContainer}>
          <Icon size="x1" icon={Clock} className={styles.clockIcon} />
          <FormattedDateTime date={eventStartTime} format="long" weekday="long" minimal />
        </span>
      </div>
      {isFlameVariantEnabled ? (
        <div className={styles.flameWrapper}>
          <PopularBetBuilderCount count={popularBetBuilderCount} eventTypeId={eventTypeId} />
        </div>
      ) : (
        <Icon size="x2" icon={getEventTypeIcon(eventTypeId)} data-testid="event-type-icon" />
      )}
    </CardHeader>
  );
};

export default EventDetailsHeader;
